var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-box",style:(_vm.bgStyle)},_vm._l((_vm.length),function(p){return _c('img',{key:p,staticClass:"bg-img",attrs:{"src":`${_vm.$store.$global.static}/${_vm.path}/${_vm.picPrefix}${p - 1}.${_vm.picType}`,"noBackground":true}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }